import { region } from './Configuration';

if (region === 'FR') {
  import(/* webpackChunkName: 'searchAutoCompleteDesktop2' */ './searchAutoCompleteImport2');
} else {
  import(/* webpackChunkName: 'searchAutoCompleteDesktop' */ './searchAutoCompleteImport');
}
